<app-liste-bdc [listeBdc]="listeBdc" [tableId]="'listeInterventions'" [datatables]="true"
              [colonnes]="'id no_bdc client prix devis_commentaire status'"></app-liste-bdc>

